import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, MapPinIcon } from 'lucide-react';
import { requests, statusLabels, statusOrder, type RequestStatus } from '../../data/demandes';
export function StatusProgress({
  status
}: {
  status: RequestStatus;
}) {
  const currentIndex = statusOrder.indexOf(status);
  return <ol className="flex items-center gap-2" aria-label={`Status: ${statusLabels[status]}`} data-id="element-909" data-mp="evmghgu12tfz">
      {statusOrder.map((step, index) => {
      const reached = index <= currentIndex;
      return <li key={step} className="flex items-center gap-2" data-id="element-910" data-mp="nt548sz23lvk" data-mpi={index}>
            <span className={`rounded-full px-3 py-1 text-xs font-bold ${index === currentIndex ? 'bg-ville-indigo text-white' : reached ? 'bg-ville-indigo-soft text-ville-indigo' : 'bg-slate-100 text-slate-400'}`} data-id="element-911" data-mp="stb4gxje6gp9">
              {statusLabels[step]}
            </span>
            {index < statusOrder.length - 1 && <span className={`h-0.5 w-5 rounded-full ${index < currentIndex ? 'bg-ville-indigo' : 'bg-slate-200'}`} aria-hidden="true" data-id="element-912" data-mp="n6ezq4rzaz0d" />}
          </li>;
    })}
    </ol>;
}
export function RequestList() {
  return <section aria-labelledby="my-requests-title" data-id="element-913" data-mp="9es0px6njcdw">
      <h2 id="my-requests-title" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-914" data-mp="163px1ju1vid6">
        My requests
      </h2>
      <p className="mt-1 text-[15px] text-slate-600" data-id="element-915" data-mp="115em15s0r1td">Follow the progress of what you have reported.</p>

      <ul className="mt-6 space-y-3" data-id="element-916" data-mp="x0yhb7u560fq">
        {requests.map(request => <li key={request.id} data-id="element-917" data-mp="s2dgb672fcq8">
            <Link to={`/my-requests/${request.id}`} className="group flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4 transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-918" data-mp="s35emos1rok7">
              <div className="min-w-0 flex-1" data-id="element-919" data-mp="3j9nuyau4x4tl">
                <div className="flex flex-wrap items-center gap-2" data-id="element-920" data-mp="3j9e64qktt3ph">
                  <h3 className="text-[15px] font-extrabold text-ville-navy" data-id="element-921" data-mp="35awjkw6npx95">{request.title}</h3>
                  <span className="text-xs font-semibold text-slate-400" data-id="element-922" data-mp="39aymf8o4owq0">{request.reference}</span>
                </div>
                <p className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-slate-500" data-id="element-923" data-mp="2vjjta90ibf58">
                  <span className="flex items-center gap-1.5" data-id="element-924" data-mp="30cmo0kh0sun0">
                    <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-925" data-mp="2lmnr0l17bp94" />
                    {request.address}
                  </span>
                  <span data-id="element-926" data-mp="2qls0lcs1fozz">{request.submittedOn}</span>
                </p>
                <div className="mt-3" data-id="element-927" data-mp="2cl7jcl1ru18l">
                  <StatusProgress status={request.status} data-id="element-928" data-mp="2cm945h8la23i" />
                </div>
              </div>
              <ChevronRightIcon className="h-5 w-5 shrink-0 text-slate-400 transition-colors duration-150 ease-ville group-hover:text-ville-indigo" aria-hidden="true" data-id="element-929" data-mp="2hjr2yesw70xs" />
            </Link>
          </li>)}
      </ul>
    </section>;
}